module.exports = __webpack_public_path__ + "static/img/IT.5b349af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/IT.png
// module id = 1L7A
// module chunks = 0